import getStore from '../store/store';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib/components/ContextualMenu';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import { lazyChangeNoteColor } from 'owa-notes';
import {
    yellow,
    green,
    pink,
    purple,
    blue,
    gray,
    charcoal,
} from './noteColorStrings.locstring.json';

const colorMap = {
    Yellow: { color: 'Yellow', text: loc(yellow), styleColor: '#fff2ab' },
    Green: { color: 'Green', text: loc(green), styleColor: '#cbf1c4' },
    Pink: { color: 'Pink', text: loc(pink), styleColor: '#ffcce5' },
    Purple: { color: 'Purple', text: loc(purple), styleColor: '#e7cfff' },
    Blue: { color: 'Blue', text: loc(blue), styleColor: '#cde9ff' },
    Gray: { color: 'Gray', text: loc(gray), styleColor: '#e1dfdd' },
    Charcoal: { color: 'Charcoal', text: loc(charcoal), styleColor: '#484644' },
};

const handleClick = (
    ev?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>,
    item?: IContextualMenuItem
): boolean | void => {
    lazyChangeNoteColor.importAndExecute(item.key);
};

export default function getChangeColorMenuProps(): IContextualMenuItem[] {
    const selectedNoteColor = getStore().selectedNoteColor;
    return Object.values(colorMap).map(colorMapValue => {
        return {
            key: colorMapValue.color,
            text: colorMapValue.text,
            canCheck: true,
            checked: selectedNoteColor == colorMapValue.color,
            onClick: handleClick,
            iconProps: { iconName: ControlIcons.CircleFill },
            itemProps: { styles: { icon: { color: colorMapValue.styleColor } } },
        };
    });
}
